<template>
    <input
        type="datetime-local"
        :value="shown"
        @mousedown="prime"
        @focus="prime"
        @input="onInput"
        @blur="onBlur"
    >
</template>

<script>
const TIME = {start: 'T00:00', end: 'T23:59'};

export default {
    props: {
        value: {default: ''},
        bound: {type: String, default: 'start'},
    },
    data() {
        return {
            primed: '',
            hold: '',
            holdTimer: null,
        };
    },
    computed: {
        shown() {
            return this.withTime(this.value) || this.primed;
        },
    },
    watch: {
        value: {
            immediate: true,
            handler(value) {
                if (value) {
                    this.primed = '';
                }

                const stored = this.forRequest(value);
                if (value && stored !== String(value).trim()) {
                    this.$emit('input', stored);
                }
            },
        },
    },
    beforeDestroy() {
        clearTimeout(this.holdTimer);
    },
    methods: {
        defaultTime() {
            return TIME[this.bound] || TIME.start;
        },
        localToday() {
            const now = new Date();
            const month = String(now.getMonth() + 1).padStart(2, '0');
            const day = String(now.getDate()).padStart(2, '0');

            return now.getFullYear() + '-' + month + '-' + day;
        },
        normalize(value) {
            if (value === null || value === undefined) {
                return '';
            }

            return String(value).trim().replace(' ', 'T');
        },
        withTime(value) {
            const text = this.normalize(value);
            if (!text) {
                return '';
            }

            const date = text.slice(0, 10);
            if (!/^\d{4}-\d{2}-\d{2}$/.test(date)) {
                return text.slice(0, 16);
            }

            if (text.length <= 10) {
                return date + this.defaultTime();
            }

            return text.slice(0, 16);
        },
        forRequest(value) {
            return this.withTime(value).replace('T', ' ');
        },
        prime(event) {
            if (this.normalize(this.value) || this.primed) {
                return;
            }

            const prime = this.localToday() + this.defaultTime();
            this.primed = prime;
            event.target.value = prime;
        },
        holdSnap(snapped) {
            this.hold = snapped;
            clearTimeout(this.holdTimer);
            this.holdTimer = setTimeout(() => {
                this.hold = '';
            }, 400);
        },
        onInput(event) {
            const raw = (event.target.value || '').slice(0, 16);
            if (!raw) {
                this.primed = '';
                this.hold = '';
                this.$emit('input', '');
                return;
            }

            const date = raw.slice(0, 10);
            const model = this.withTime(this.value);
            const modelDate = model.slice(0, 10);
            const snapped = date + this.defaultTime();

            if (date !== modelDate) {
                this.primed = '';
                this.holdSnap(snapped);
                event.target.value = snapped;
                if (model !== snapped) {
                    this.$emit('input', this.forRequest(snapped));
                }
                return;
            }

            if (this.hold && raw !== this.hold) {
                event.target.value = this.hold;
                return;
            }

            this.hold = '';
            this.primed = '';
            if (raw !== model) {
                this.$emit('input', this.forRequest(raw));
            }
        },
        onBlur() {
            this.hold = '';
            if (!this.normalize(this.value)) {
                this.primed = '';
            }
        },
    },
};
</script>
